import type { CagnotteProvider } from '@shared/types';

/**
 * Detect the cagnotte provider from a URL.
 * Returns 'autre' for any unrecognised URL or invalid input.
 *
 * Supported providers (9):
 *   lydia, helloasso, lepotcommun, leetchi, gofundme,
 *   tipeee, kisskissbankbank, paypal, autre
 */
export function detectCagnotteProvider(rawUrl: string): CagnotteProvider {
  if (!rawUrl || typeof rawUrl !== 'string') return 'autre';

  let host: string;
  try {
    const u = new URL(rawUrl.trim());
    host = u.hostname.toLowerCase().replace(/^www\./, '');
  } catch {
    return 'autre';
  }

  if (host.endsWith('lydia-app.com') || host.endsWith('lydia.me') || host.includes('lydia')) {
    return 'lydia';
  }
  if (host.endsWith('helloasso.com')) return 'helloasso';
  if (host.endsWith('lepotcommun.fr')) return 'lepotcommun';
  if (host.endsWith('leetchi.com')) return 'leetchi';
  if (host.endsWith('gofundme.com')) return 'gofundme';
  if (host.endsWith('tipeee.com')) return 'tipeee';
  if (host.endsWith('kisskissbankbank.com')) return 'kisskissbankbank';
  if (host.endsWith('paypal.com') || host.endsWith('paypal.me')) return 'paypal';

  return 'autre';
}
